import React, { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { fmtDateTime } from "@/lib/format";
import { fmtDays, fmtH } from "@/lib/people";

const KIND = { entitlement: "Entitlement", adjustment: "Adjustment", taken: "Leave booked", reversal: "Leave returned" };

// Read-only audit trail: every change to a balance is a separate, signed entry.
export function LedgerDialog({ orgId, userId, name, type, year, yearLabel, dayHours, onClose }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get(`/workspace/leave/ledger?org_id=${orgId}&user_id=${userId}&leave_type_id=${type.id}&year=${year}`).then((r) => setRows(r.data));
  }, [orgId, userId, type.id, year]);
  let running = 0;
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-h-[88vh] max-w-2xl overflow-y-auto" data-testid="ledger-dialog">
        <DialogHeader>
          <DialogTitle>{type.name} history · {yearLabel}</DialogTitle>
          <DialogDescription>{name ? `${name} — ` : ""}every entitlement, adjustment and booking, in order. Entries are never edited or deleted.</DialogDescription>
        </DialogHeader>
        {!rows ? <Icons.Loader2 className="mx-auto animate-spin text-[#FFB000]" /> : rows.length === 0 ? (
          <p className="py-6 text-center text-sm text-[#1E2D44]/45">No entries yet.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full min-w-[520px] text-sm" data-testid="ledger-table">
              <thead><tr className="border-b border-[#E4E8EF] text-left text-xs uppercase tracking-wide text-[#1E2D44]/45">
                <th className="py-2 pr-3">When</th><th className="py-2 pr-3">What</th><th className="py-2 pr-3 text-right">Change</th><th className="py-2 pr-3 text-right">Balance</th><th className="py-2">By</th>
              </tr></thead>
              <tbody>
                {rows.map((e) => {
                  running += e.hours;
                  return (
                    <tr key={e.id} className="border-b border-[#EEF1F6] align-top">
                      <td className="py-2 pr-3 text-xs text-[#1E2D44]/55">{fmtDateTime(e.created_at)}</td>
                      <td className="py-2 pr-3"><div className="font-medium text-[#0B1729]">{KIND[e.kind]}</div><div className="text-xs text-[#1E2D44]/55">{e.note}</div></td>
                      <td className={`py-2 pr-3 text-right font-semibold ${e.hours < 0 ? "text-[#C95555]" : "text-[#3D8B65]"}`}>{e.hours > 0 ? "+" : ""}{fmtH(e.hours)}</td>
                      <td className="py-2 pr-3 text-right text-[#0B1729]">{fmtDays(running, dayHours)}</td>
                      <td className="py-2 text-xs text-[#1E2D44]/55">{e.created_by_name}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
